import React from 'react'
import { Result } from 'antd'
import { ReactComponent as Error } from 'style/icons/under_construction.svg'


function GlobalSettings() {
	return (
        <Result
        status="error"
        icon={<Error width={360} height={360} />}
        title="Under Construction"
        subTitle="Please visit in future."
    />
	)
}

export default GlobalSettings
